import {
    SET_UPFIT_OPTION,
} from "./UpfitOptionType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_UPFIT_OPTION:
            return {
                ...state,
                upfitOptionDropDown: action.upfitOptionList,
            };
        default:
            return state;
    }
};

export default reducer;
